// extracted by mini-css-extract-plugin
module.exports = {"postCategoriesWrapper":"postCategories-module--postCategoriesWrapper--jT7qE","category":"postCategories-module--category--2TzOI"};